var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBobaAvatar5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4535204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4852 41.495C31.7709 41.495 40.9197 32.3582 40.9197 21.0874C40.9197 9.81652 31.7709 0.679688 20.4852 0.679688C9.19959 0.679688 0.0507812 9.81652 0.0507812 21.0874C0.0507812 32.3582 9.19959 41.495 20.4852 41.495Z",
    fill: "#E5D1B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.3963 23.6314L30.7315 3.70533C30.7315 3.70533 20.6198 -4.00022 8.2476 4.90933C8.2928 4.90933 -2.1354 11.2604 0.3963 23.6314Z",
    fill: "#A83C31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.70521 20.5254C4.70521 20.5254 10.6446 29.1501 11.709 30.4723C12.1101 30.9642 32.5354 16.0056 32.5354 16.0056C32.5354 16.0056 27.5062 8.53392 26.0252 6.45846L31.0544 3.19922C34.3298 5.175 37.0279 7.97234 38.8795 11.312C40.7311 14.6517 41.6713 18.417 41.6064 22.2319C41.6064 22.2319 42.2851 29.5652 33.4918 37.3597C30.9679 39.2468 28.0789 40.5922 25.007 41.3108C19.2374 42.5099 12.4032 41.0955 8.62366 37.9593C8.62366 37.9593 1.2033 34.285 0 23.5541L4.70521 20.5254Z",
    fill: "#40507C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.8203 19.945L21.8566 12.7059L30.2957 11.502C30.2957 11.502 32.526 14.7527 26.7091 17.0253C26.7091 17.0253 26.9351 22.1272 20.6812 21.8713C20.6812 21.8713 18.6317 26.9883 14.3821 25.3027C14.3821 25.3027 10.5845 29.8177 7.41992 27.5151L11.8203 19.945Z",
    fill: "#62412A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.98489 23.1504C11.4651 23.1504 13.4756 21.1425 13.4756 18.6655C13.4756 16.1886 11.4651 14.1807 8.98489 14.1807C6.50472 14.1807 4.49414 16.1886 4.49414 18.6655C4.49414 21.1425 6.50472 23.1504 8.98489 23.1504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.3365 14.044C24.8166 14.044 26.8272 12.036 26.8272 9.5591C26.8272 7.08217 24.8166 5.07422 22.3365 5.07422C19.8563 5.07422 17.8457 7.08217 17.8457 9.5591C17.8457 12.036 19.8563 14.044 22.3365 14.044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20.786 12.87C22.3839 12.87 23.6793 11.5763 23.6793 9.98041C23.6793 8.38453 22.3839 7.09082 20.786 7.09082C19.188 7.09082 17.8926 8.38453 17.8926 9.98041C17.8926 11.5763 19.188 12.87 20.786 12.87Z",
    fill: "#62412A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.07306 21.5536C8.67103 21.5536 9.96643 20.2599 9.96643 18.664C9.96643 17.0681 8.67103 15.7744 7.07306 15.7744C5.47509 15.7744 4.17969 17.0681 4.17969 18.664C4.17969 20.2599 5.47509 21.5536 7.07306 21.5536Z",
    fill: "#62412A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobaAvatar5);
export default __webpack_public_path__ + "static/media/boba-avatar-5.bbeba6dd.svg";
export { ForwardRef as ReactComponent };